import * as React from 'react';

const SectionJustifySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="#010101"
            d="M5 17h14v2H5v-2zm-1 3h16v-4H4v4zM4 10v4h16v-4H4zm15 3H5v-2h14v2zM4 4v4h16V4H4zm15 3H5V5h14v2z"
        />
    </svg>
);

SectionJustifySvg.displayName = 'SectionJustifySvg';
export default SectionJustifySvg;
